module.exports = __webpack_public_path__ + "img/26_190.14ded769.png";